import PlusIcon from "../../assets/images/icons/PlusIcon.svg";
import Input from "../Input/Input";
import ModalComponent from "../Modal/Modal";
import React, { useEffect, useState } from "react";
import { createCustomer } from "../../features/admin/adminSlice";
import { useDispatch } from "react-redux";
import { showSnackBar } from "../Snackbar/Snackbar";
import { areFieldsNotEmpty } from "../../helpers/helper";
import Calendar from "../Calendar/Calendar";
import { dateToServer } from "../../utils/date";
import { phoneNumber } from "../../utils/payment";
import { useMyContextLoading } from "../LoadingContextProvider/LoadingContextProvider";

const AddCustomerModal = ({ setUpdateTable, onCreateCustomer, setOnCreateCustomer }) => {
  const dispatch = useDispatch();
  const { triggerLoading } = useMyContextLoading();
  const [reqError, setReqError] = useState('');
  const [password, setPassword] = useState('');
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    primaryPhone: '',
    email: '',
    address: '',
    aptNumber: '',
    city: '',
    state: '',
    zip: '',
    password: '',
    dateOfBirth: '',
  });

  useEffect(() => {
    setFormData((prevData) => ({ ...prevData, ["password"]: password }))
  }, [password])

  useEffect(() => {
    const handleReqError = () => {
      reqError?.length > 0 && showSnackBar("error", reqError)
      setReqError('')
    }

    handleReqError()
  }, [reqError])

  const handleCreateCustomer = async () => {
    triggerLoading(true)
    if (!formData.password || !formData.firstName || !formData.lastName || !formData.email) {
      showSnackBar("error", "First name, Last name, Email and Password fields are required!")
    } else {
      const newNumber = formData?.primaryPhone?.replace(/\D/g, "")
      const response = await dispatch(createCustomer({
        ...formData,
        primaryPhone: newNumber,
        dateOfBirth: dateToServer(formData.dateOfBirth),
      }));
      resetFormData()
      setUpdateTable(true)
      setOnCreateCustomer(!onCreateCustomer)

      if (response.error) {
        setReqError(response.payload)
      } else if (response) {
        showSnackBar("success", "Customer successfully created");
      }
    }
    triggerLoading(true)
  }

  const resetFormData = () => {
    setFormData(
      {
        firstName: '',
        lastName: '',
        primaryPhone: '',
        email: '',
        address: '',
        aptNumber: '',
        city: '',
        state: '',
        zip: '',
        password: '',
        dateOfBirth: '',
      }
    )
  }
  const handleInputChange = ({ name, value }) => {
    switch (name) {
      case 'primaryPhone':
        setFormData((prevData) => ({ ...prevData, [name]: phoneNumber(value)}))
        break;
      default:
        setFormData((prevData) => ({ ...prevData, [name]: value }))
        break;
    }
  };

  return (
    <ModalComponent modalButtonTitle="Submit" title="Add New Customer"
                    functionButton={handleCreateCustomer}
                    disabled={!areFieldsNotEmpty([formData.firstName, formData.lastName, formData.email, formData.ssNumber, formData.password]) || formData.dateOfBirth === ''}
                    onClose={resetFormData}
                    buttonClasses="flex h-9 items-center" buttonTitle={
      <>
        <img src={PlusIcon} alt="plus"/>
        <p>Add Customer</p>
      </>
    }>
      <div className="max-w-[630px]">
        <div className="grid grid-cols-2 gap-x-4 gap-y-6 mb-6 items-center">
          <Input width="w-[300px]" placeholder="Enter First Name" label="First name *" value={formData.firstName}
                 onChange={(e) => handleInputChange({ name: 'firstName', value: e.target.value })}/>
          <Input width="w-[300px]" placeholder="Enter Last Name" label="Last name *" value={formData.lastName}
                 onChange={(e) => handleInputChange({ name: 'lastName', value: e.target.value })}/>
          <Input width="w-[300px]" placeholder="Enter Primary Phone" label="Primary Phone" value={formData.primaryPhone}
                 onChange={(e) => handleInputChange({ name: 'primaryPhone', value: e.target.value })}/>
          <Input type="email" width="w-[300px]" placeholder="Enter Email" label="Email *" value={formData.email}
                 onChange={(e) => handleInputChange({ name: 'email', value: e.target.value })}/>
          <Input width="w-[300px]" placeholder="Enter Address" label="Address" value={formData.address}
                 onChange={(e) => handleInputChange({ name: 'address', value: e.target.value })}/>
          <Input width="w-[300px]" placeholder="34" label="Suite/Apt#" value={formData.aptNumber}
                 onChange={(e) => handleInputChange({ name: 'aptNumber', value: e.target.value })}/>
          <Input width="w-[300px]" placeholder="Enter City" label="City" value={formData.city}
                 onChange={(e) => handleInputChange({ name: 'city', value: e.target.value })}/>
          <Input width="w-[300px]" placeholder="Enter State" label="State" value={formData.state}
                 onChange={(e) => handleInputChange({ name: 'state', value: e.target.value })}/>
          <Input width="w-[300px]" placeholder="Enter Zip" label="Zip" value={formData.zip}
                 onChange={(e) => handleInputChange({ name: 'zip', value: e.target.value })}/>
          <Calendar
            width="w-[300px]"
            label="Date Of Birth *"
            optional
            value={formData.dateOfBirth}
            onChange={(e) => handleInputChange({ name: 'dateOfBirth', value: e })}
            isRequired={true}
          />
        </div>
      </div>
    </ModalComponent>
  )
}
export default AddCustomerModal
